<app-wi-data-modal
  [isOpen]="isOpen"
  title="Select a reason for rewash"
  width="560px"
  panelClass="rewash-reason-modal--panel"
  bodyClass="rewash-reason-modal__body"
  ariaLabel="Select a reason for rewash"
  dialogId="rewash-reason-modal"
  (modalClose)="close()"
>
  <p *ngIf="isLoading" class="rewash-reason-modal__status" aria-live="polite">Loading reasons...</p>
  <p *ngIf="!isLoading && loadError" class="rewash-reason-modal__status rewash-reason-modal__status--error" role="alert">
    {{ loadError }}
  </p>

  <div class="rewash-reason-modal__options" *ngIf="!isLoading && !loadError">
    <label
      *ngFor="let preset of presets"
      class="rewash-reason-option"
      [class.rewash-reason-option--selected]="selectedReason === preset.slug"
    >
      <span class="rewash-reason-option__label">{{ preset.label }}</span>
      <span class="rewash-reason-option__radio-wrap" aria-hidden="true">
        <input
          type="radio"
          class="rewash-reason-option__radio"
          name="rewashReason"
          [value]="preset.slug"
          [(ngModel)]="selectedReason"
        />
      </span>
    </label>

    <div
      class="rewash-reason-option--others"
      [class.rewash-reason-option--selected]="isOthersSelected"
    >
      <label class="rewash-reason-option">
        <span
          class="rewash-reason-option__label"
          [class.rewash-reason-option__label--bold]="isOthersSelected"
        >Others</span>
        <span class="rewash-reason-option__radio-wrap" aria-hidden="true">
          <input
            type="radio"
            class="rewash-reason-option__radio"
            name="rewashReason"
            [value]="othersValue"
            [(ngModel)]="selectedReason"
          />
        </span>
      </label>
      <textarea
        *ngIf="isOthersSelected"
        class="rewash-reason-modal__textarea"
        [(ngModel)]="customReasonText"
        [attr.maxlength]="customReasonMaxLength"
        placeholder="Type your reason here"
        rows="3"
        aria-label="Custom rewash reason"
      ></textarea>
    </div>
  </div>

  <div modal-footer class="rewash-reason-modal__footer">
    <p *ngIf="submitError" class="rewash-reason-modal__submit-error" role="alert">{{ submitError }}</p>
    <button
      type="button"
      class="rewash-reason-modal__confirm"
      [disabled]="!canConfirm"
      (click)="onConfirm()"
    >
      {{ isSubmitting ? 'Confirming...' : 'Confirm' }}
    </button>
  </div>
</app-wi-data-modal>
